import { FC } from "react"

const MyEvents: FC = () => <></>

export default MyEvents
